import {RouteConfig} from "vue-router";
import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import {ifAuthenticated} from "@/routes/access";

import Balances from "@/pages/Pages/Finances/Balances.vue";

const financesMenu: RouteConfig = {
    path: "/",
    component: DashboardLayout,
    beforeEnter: ifAuthenticated,
    children: [
        {
            path: "/finances/balances",
            name: "balances",
            components: {default: Balances},
            meta: {
                icon: "account_balance_wallet",
                msgKey: 'menu.item.financial.history'
            }
        },
    ]
}

export default financesMenu;
